module.exports = __webpack_public_path__ + "static/media/meter-circle.3de87b42.svg";